import { ReactComponent as CloseIcon } from 'assets/icons/fa-xmark.svg';
import React, { useCallback, useMemo } from 'react';
import './mapFloorPlan.scss';
import ViewPointMapPlan from './ViewPointMapPlan';
import { useMediaQuery } from 'react-responsive';

const MapFloorPlan = ({
  currentPano,
  floorMaps,
  selectSceneById,
  toggleMapFloorPlan,
  handleToggleFloorPlan,
}) => {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  const mapShowed = useMemo(() => {
    if (floorMaps.length > 0 && currentPano) {
      const getCurrentMap = (floorMaps, pano) => {
        return floorMaps.find((item) =>
          item.objects.length
            ? item.objects.some((obj) => obj.id === pano._id)
            : item
        );
      };

      return getCurrentMap(floorMaps, currentPano);
    } else return;
  }, [floorMaps, currentPano]);

  const handleMapClick = useCallback((event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    // eslint-disable-next-line
    const x = (event.clientX - rect.left) / rect.width;
    // eslint-disable-next-line
    const y = (event.clientY - rect.top) / rect.height;

    console.log(`Clicked position: (${x.toFixed(4)}, ${y.toFixed(4)})`);
  }, []);

  const hardcodeMapFloorPlanSize = useMemo(
    () => currentPano?._id === '675166bb97d14bbd943b566d',
    [currentPano]
  );

  return (
    <div
      className={`map-floorplan-container${toggleMapFloorPlan ? ' open' : ''}`}
      onClick={handleMapClick}
      style={{
        pointerEvents: 'all',
        width: hardcodeMapFloorPlanSize ? 400 : isMobile ? 170 : 230,
      }}
    >
      <div className="map-floorplan-close-btn" onClick={handleToggleFloorPlan}>
        <CloseIcon className="icon" />
      </div>
      <img src={mapShowed?.image.url} alt={mapShowed?.image.name} />
      {mapShowed?.objects?.map((viewpoint) => {
        return (
          <React.Fragment key={viewpoint.id}>
            <ViewPointMapPlan
              viewpoint={viewpoint}
              currentPano={currentPano}
              selectSceneById={selectSceneById}
            />
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default MapFloorPlan;
